import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {Spin} from 'antd';

import {INDEX} from '../../config/routes';
import {getMobileOperatingSystem} from '../../shared/helpers/detectUserAgent';

export const Download = () => {

    const os = getMobileOperatingSystem()
    const navigate = useNavigate()

    const androidUrl = 'https://play.google.com/store/apps/details?id=space.aevitas.app';
    const iosUrl = 'https://apps.apple.com/app/vita/id6744920674';

    useEffect(() => {
        if (os === 'iOS') {
            window.location.assign(iosUrl)
        } else if (os === 'Android') {
            window.location.assign(androidUrl)
        } else {
            navigate(INDEX)
        }
    }, [navigate, os])

    return <Spin/>
}